/**
 * FigmaLandingPageB — homepage arm B (#1070): arm A, unchanged, plus two
 * product-scene strips in the slots A leaves for them.
 *
 * Section order: hero, Pain points, Strip A ("Every reflection, ready to
 * revisit"), Time capsule, Strip B ("Talk for a minute. Get back what stood
 * out"), Features, then the rest of A. Arm A's copy, styles and CTAs are its
 * own; this file adds only the strips and their stylesheet. The design is
 * Lena's approved `Homepage B.dc.html`.
 */
import { useTranslations } from "next-intl";

import { STRIP_A_CTA, STRIP_B_CTA } from "../../ctaVariants";
import FigmaLandingPageA from "../figmaA/FigmaLandingPageA";

import StripRevisit from "./StripRevisit";
import StripStepper from "./StripStepper";
import "./figmaVariantB.css";

/**
 * Arm B. Takes the same {@link import("../registry").HomepageVariantProps}
 * every arm does and forwards them to arm A.
 *
 * @param {import("../registry").HomepageVariantProps} props
 */
const FigmaLandingPageB = ({ isAuthenticated, offersLogIn, onCTAClick }) => {
  const t = useTranslations("web.home");
  // Worded as arm A words its primary CTAs: a signed-in visitor is offered
  // the app, not an account.
  const ctaLabel = isAuthenticated ? t("cta.signedIn") : t("cta.startJournal");
  const stripA = <StripRevisit ctaLabel={ctaLabel} onCta={() => onCTAClick(STRIP_A_CTA)} />;
  const stripB = <StripStepper ctaLabel={ctaLabel} onCta={() => onCTAClick(STRIP_B_CTA)} />;

  return (
    <FigmaLandingPageA
      isAuthenticated={isAuthenticated}
      offersLogIn={offersLogIn}
      onCTAClick={onCTAClick}
      afterPainPoints={stripA}
      afterVision={stripB}
    />
  );
};

export default FigmaLandingPageB;
